import Icon from 'atoms/Icon';
import Text from 'atoms/Text';
import useClickOutside from 'components/useClickOutSide';
import { useRef, useState } from 'react';
import ActionDropBox from './ActionDropBox';
import SearchableSelect from './SearchableSelect';
import CustomMultiSelect from './CustomMultiSelect';
import CustomAsyncSelectPaginate from './CustomAsyncSelectPaginate';
import CustomAsyncSelect from './CustomAsyncSelect';

function FilterSelect({
    control,
    register,
    name,
    placeholder,
    options,
    watch,
    onRemove,
    label,
    loadOptions = () => { },
    isMulti = true,
    setValue,
    isPaginate = false,
    dropdownWidth = 'md:w-[19rem]',
    containerWidth = 'max-w-[200px]',
    isDisablePagination = false,
    hideActionButtons = false,
   ...rest
}) {
    const [showFilter, setShowFilter] = useState(false);
    const ref = useRef();

    useClickOutside(ref, () => setShowFilter(false));

    const actionButtons = [
        {
            label: 'Remove',
            kind: 'silent',
            onClick: onRemove
        },
        {
            label: 'Close',
            kind: 'secondaryLoud',
            onClick: () => setShowFilter(false),
            className: '!flex md:!hidden'
        },
        {
            label: 'Ok',
            onClick: () => setShowFilter(false)
        }
    ];


    const Component = isMulti ? isPaginate ? CustomAsyncSelectPaginate : CustomAsyncSelect : SearchableSelect;

    return (
        <div className='relative'>
            <div
                className={`border bg-white border-gray-200 px-2 h-8 text-xs flex justify-between items-center gap-3 cursor-pointer ${containerWidth}`}
                onClick={() => setShowFilter(!showFilter)}
            >
                <Text className='truncate' variant='label'>
                    {placeholder}: {isMulti ? watch(name)?.map(item => item.label + ', ') : watch(name)?.value}
                </Text>
                <Icon icon='chevron_down__l__stroke' size='w-3 h-3' />
            </div>
            {
                showFilter && (
                    <div ref={ref}>
                        <ActionDropBox
                            label={label}
                            onClose={() => setShowFilter(false)}
                            buttons={hideActionButtons ? [] : actionButtons}
                            width={dropdownWidth}
                        >
                            <Component
                                cacheOptions
                                loadOptions={(input, {}, page) => loadOptions(input, watch(), page)}
                                control={control}
                                register={register}
                                name={name}
                                components={isMulti ? { Option: CustomMultiSelect } : {}}
                                isMulti={isMulti}
                                show
                                value={watch(name)}
                                watch={watch}
                                closeMenuOnSelect={false}
                                menuPosition='absolute'
                                menuPlacement='bottom'
                                options={options}
                                placeholder={'Search or select one more options'}
                                size='sm'
                                className='filter-select dark'
                                defaultMenuIsOpen
                                menuIsOpen
                                hideSelectedOptions={false}
                                defaultOptions={options ?? []}
                                autoFocus
                                setValue={setValue}
                                isDisablePagination={isDisablePagination}
                                {...rest}
                            />
                        </ActionDropBox>
                    </div>
                )
            }
        </div>
    )
}

export default FilterSelect